(function () {
    var SelectAllMultiSelectButton = function ($el) {
        this.$el = $el
        this.multiSelectSelector = this.$el.data('multiSelectSelector')
        this.$multiSelect = $(this.multiSelectSelector)

        console.log('hello');
        console.log($el);

        this.bindEvents()
    }

    SelectAllMultiSelectButton.prototype.bindEvents = function () {
        this.$el.on('click', this.selectAll.bind(this))
    }

    SelectAllMultiSelectButton.prototype.selectAll = function (event) {
        event.preventDefault()
        this.$multiSelect.selectpicker('selectAll')
    }

    $('.select-all-multi-select-btn').each(function () {
        new SelectAllMultiSelectButton($(this))
    })
})()
